import { render, staticRenderFns } from "./codeList.vue?vue&type=template&id=1187d61e&scoped=true&"
import script from "./codeList.vue?vue&type=script&lang=js&"
export * from "./codeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1187d61e",
  null
  
)

export default component.exports